import React from 'react';
import { Link } from 'react-router-dom';
import { Arrow } from './Icons';

function ContactBanner() {
  return <section className="contact-banner"><div><span className="eyebrow">DO YOU NEED SOME CONSULTING?</span><h2>Contact us</h2></div><Link className="button accent-button" to="/contact">Contact us <Arrow diagonal /></Link><div className="contour" aria-hidden="true">{Array.from({length: 8}, (_, i) => <span key={i} style={{inset: `${i * 16}px`}} />)}</div></section>;
}

export default ContactBanner;
